
const SUBSCRIPTION_ENDPOINTS = {
  GET_SUBSCRIPTION_DATA: '/frontend/plans-with-features',
};

export default SUBSCRIPTION_ENDPOINTS;